/** Deduplicate concurrent in-flight GET requests — React Query owns response freshness. */
const activeGetRequests = new Map<string, Promise<unknown>>();

/**
 * Dedupe In Flight Get.
 */
export function dedupeInFlightGet<T>(key: string, factory: () => Promise<T>): Promise<T> {
  const existing = activeGetRequests.get(key);
  if (existing !== undefined) {
    return existing as Promise<T>;
  }

  const requestPromise = factory().finally(() => {
    activeGetRequests.delete(key);
  });
  activeGetRequests.set(key, requestPromise);
  return requestPromise;
}

/** Clears in-flight GET dedup state (e.g. on query invalidation). */
export function clearInFlightGetDedup(): void {
  activeGetRequests.clear();
}

/** @internal test helper */
export function resetInFlightGetDedupForTests(): void {
  activeGetRequests.clear();
}
